import { Client, Patient } from 'src/interfaces';

const hasPhoto = (obj: Patient | Client) =>
  !!obj.photo.urls.original && !obj.photo.urls.original?.match(/photo_missing/);

export default hasPhoto;
